<script setup lang="ts">
import type { UmbracoFormField } from 'types/blocks';

const formStore = useFormStore();
const { getLabel, showLabel } = useForm();

const props = defineProps<{
  field: UmbracoFormField;
}>();

const fieldValue = ref('');
const hasBeenTouched = ref<boolean>(false);
const input = useTemplateRef('input');

watch(fieldValue, (newValue) => {
  formStore.setFieldValue(props.field.alias, newValue);
});
</script>

<template>
  <div class="flex w-full flex-col">
    <Label
      v-if="showLabel(field)"
      class="form__label"
      :for="field.id"
    >
      {{ getLabel(field) }}
    </Label>

    <span
      v-if="field.placeholder"
      class="form__help-message"
      >{{ field.placeholder }}</span
    >
    <span
      v-if="hasBeenTouched && !input?.checkValidity()"
      class="form__error-message"
    >
      <BaseIcon
        name="error"
        fill-color="var(--color-form-invalid)"
        stroke-color="var(--color-white-pure)"
        size="20px"
      />
      {{ field.requiredErrorMessage || $t('FormMessages.General.Required') }}
    </span>
    <input
      :id="field.id"
      ref="input"
      v-model="fieldValue"
      type="tel"
      :name="field.alias"
      :disabled="formStore.isDisabled"
      :autocomplete="field.settings.autocompleteAttribute || 'tel'"
      :required="field.required"
      @blur="hasBeenTouched = true"
    />
  </div>
</template>
